var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-table',[_c('tbody',_vm._l((_vm.charges),function(charge,index){return _c('tr',{key:index,attrs:{"role":"button"},on:{"click":function($event){return _vm.show(charge)}}},[_c('td',[_vm._v(_vm._s(charge.selflane_net))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("datetime")(charge.created)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }